module.exports = { baseUrl: process.env.REACT_APP_BASEURL };
